import React, { useEffect, useState } from "react";
import { SidePopup } from "../../../components/model-popup/side-popup";
import { CustomButton } from "../../../components/buttons/button";
import { toast } from "react-toastify";
import { WordTitle } from "../../../utils/commonFunction";

// formik
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";

// components
import NotesDocs from "../notes_docs";
import TextIconInput from "../../../components/custom-fields/input";
import ErrorMessage from "../../../components/custom-fields/error-message";

// api
import { UpdateNotesSourceDetailsAPI } from "../../../api/update";

// --- Workaround so SidePopup accepts children
const SidePopupAny = SidePopup as React.ComponentType<any>;

export const DosMismatchPopup = ({
  showModal,
  setShowModal,
  title,
  handleClose,
  poupDetails,
  afterChangeNotesList
}: any) => {

  const [buttonLoader, setButtonLoader] = useState<boolean>(false);

  const ConvertDate = (date_string: string) => {
    const isValidFormat: boolean = moment(date_string, "YYYY-MM-DD", true).isValid();
    const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["MM/DD/YYYY", "DD/MM/YYYY"]).format("YYYY-MM-DD");
    return formattedDate
  };

  const ConvertOutputDate = (date_string: string) => {
    const isValidFormat: boolean = moment(date_string, "YYYY-MM-DD", true).isValid();
    const formattedDate: string = isValidFormat ? date_string : moment(date_string, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD");
    return formattedDate
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      encounter_date: poupDetails?.encounter_date ? ConvertDate(poupDetails?.encounter_date) : "",
    },
    validationSchema: yup.object({
      encounter_date: yup.string().required("Date of Service is required"),
    }),
    onSubmit: async (values) => {
      setButtonLoader(true);
      const data = {
          encounter_date: ConvertOutputDate(values.encounter_date),
      }
      await UpdateNotesSourceDetailsAPI(poupDetails?.id, data)
        .then(async (res: any) => {

          if (res?.result) {
            toast.success(res?.result?.message || "Notes details updated successfully");
            setShowModal(false);
            afterChangeNotesList();
          } else {
            if (res?.message)
              toast.error(res?.message || "Notes details updated failed");
          }
        })
        .catch((err: any) => {
          console.error(err);
        });

      setButtonLoader(false);
    },
  });


  return (
    <SidePopupAny
      showModal={showModal}
      handleClose={handleClose}
      width="max-w-[1000px]"
      title={title}
      footerStyle="flex justify-end gap-[16px] "
      footerContent={
        <>
          <CustomButton
            buttonStyle="text-[#031227] bg-white hover:bg-[#F5F5F5] disabled:bg-white disabled:text-[#AAADB1]  px-[26px] py-[12px] text-[14px] font-semibold leading-[17px] border-[#E8ECF4] "
            buttonName="Cancel"
            primary={false}
            loader={buttonLoader}
            onClick={() => {
              setShowModal(false)
            }}
          />
          <CustomButton
            buttonName="Update"
            buttonStyle="text-white px-[36px] py-[12px] text-[14px] font-semibold leading-[17px] hover:bg-[#166B5E] disabled:bg-[#75C8BB]  "
            primary
            loader={buttonLoader}
            onClick={() => formik.handleSubmit()}
            type="button"
          />
        </>
      }
    >
      <div className="grid grid-cols-[49%_49%]  gap-x-2">

        <NotesDocs id={poupDetails?.id} />

        {/* Notes Details and Update Location */}
        <div className="border border-gray-200 rounded-lg shadow-sm h-[calc(100vh-180px)] overflow-y-auto">
          <div className="font-normal text-gray-800 text-base bg-gray-200 py-2.5 px-4 rounded-t-lg">Source Note Details</div>
          <div className="grid grid-cols-[30%_70%]  gap-y-1 p-3 rounded text-sm">
            <div className="font-medium">Patient Name:</div>
            <div className="max-w-[250px] truncate">
              {![null, "", undefined].includes(poupDetails?.patient_last_name) && ![null, "", undefined].includes(poupDetails?.patient_first_name)
                ? `${WordTitle(poupDetails?.patient_last_name || '')}, ${WordTitle(poupDetails?.patient_first_name || '')}`
                : (WordTitle(poupDetails?.patient_last_name || '') || WordTitle(poupDetails?.patient_first_name || '') || 'N/A')}
            </div>
            <hr className="my-[0.2rem] shadow-md col-span-2" />
            <div className="font-medium">Date of Birth:</div>
            <div className="max-w-[250px] truncate">
              {poupDetails?.DOB || '' || 'N/A'}
            </div>
            <hr className="my-[0.2rem] shadow-md col-span-2" />
            <div className="font-medium">Date of Service:</div>
            <div className="max-w-[250px] truncate" title={poupDetails?.encounter_date || ''}>
              {poupDetails?.encounter_date || '' || 'N/A'}
            </div>
            <hr className="my-[0.2rem] shadow-md col-span-2" />
            <div className="font-medium">Sender:</div>
            <div className="max-w-[250px] truncate" title={poupDetails?.sender_name || ''}>
              {WordTitle(poupDetails?.sender_name || '') || 'N/A'}
            </div>
            <hr className="my-[0.2rem] shadow-md col-span-2" />
            <div className="font-medium">Location:</div>
            <div className="max-w-[250px] truncate" title={poupDetails?.location || ''}>
              {WordTitle(poupDetails?.location || '') || 'N/A'}
            </div>
            <hr className="my-[0.2rem] shadow-md col-span-2" />
            <div className="font-medium">Error description:</div>
            <div className="max-w-[250px] truncate " title={poupDetails?.error_detail || ''}>
              {WordTitle(poupDetails?.error_detail || '') || ''}
            </div>
          </div>
          <div className="font-normal  text-gray-800 text-base bg-gray-200 py-2 px-4 mt-1">Update Note details</div>
          <div className="w-full col-span-1 p-3">
            <TextIconInput
              divStyle="mt-[2px]"
              label={"Date of Service"}
              minLength={4}
              placeholder="Patient date of brith"
              maxLength={50}
              name="encounter_date"
              id="encounter_date"
              value={formik.values.encounter_date}
              errors={formik.errors.encounter_date
                && formik.touched.encounter_date}
              onChange={formik.handleChange}
              disable={buttonLoader}
              onBlur={formik.handleBlur}
              type={"date"}
              required
            />

            {formik.errors.encounter_date && formik.touched.encounter_date ? (
              <ErrorMessage>{formik.errors.encounter_date}</ErrorMessage>
            ) : (
              <span>&nbsp;</span>
            )}
          </div>
        </div>
      </div>
    </SidePopupAny>
  );
};
